module.exports = __webpack_public_path__ + "img/home-delivery@2x.d4dc0e3e.webp";